/**
 * Feature Flag Enum
 *
 * Defines all available feature flags in the application.
 * Backend flags are synced from the API, frontend-only flags are checked from environment.
 */
export enum FeatureFlag {
  // Backend feature flags (synced from API)
  ENABLE_IBC_SUBMISSIONS = 'enable_ibc_submissions',
  APPEAL_SUBMISSIONS = 'appeal_submissions',
  UNIFIED_GRID = 'unified_grid',
  SYSTEM_OPERATIONS_API = 'system_operations_api',
  FEATURE_FLAG_MANAGEMENT = 'feature_flag_management_ui',
  USER_SITE_SERVICE_V2 = 'use_site_service_v2',
  MANUAL_COLLAB_HUB_NOTIFICATIONS = 'manual_collab_hub_notifications',

  // Frontend-only feature flags (checked from environment)
  ENABLE_MOCK_IRIS = 'enableMockIris',
}
